import Cookies from 'js-cookie';

// Chatwoot'un dashboard API'si devise_token_auth header'larıyla (access-token/
// client/uid/expiry/token-type) korunuyor — bunlar oturum açıldığında
// 'cw_d_session_info' cookie'sine JSON olarak yazılıyor (bkz. dashboard/api/auth.js).
// Bu sayfalar Vuex/axios store'u kullanmadığı için ham fetch() çağrılarına
// bu header'ları elle eklememiz gerekiyor, aksi halde her istek 401 döner.
const authHeaders = () => {
  const raw = Cookies.get('cw_d_session_info');
  if (!raw) return {};
  try {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = JSON.parse(raw);
    return {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    };
  } catch {
    return {};
  }
};

export const marketplaceApiUrl = (accountId, path) =>
  `/api/v1/accounts/${accountId}/marketplace/${path}`;

export const fetchMarketplaceJson = async (accountId, path) => {
  const response = await fetch(marketplaceApiUrl(accountId, path), {
    headers: authHeaders(),
  });
  if (!response.ok) throw new Error(`${path} -> HTTP ${response.status}`);
  return response.json();
};

export const postMarketplaceJson = async (accountId, path) => {
  const response = await fetch(marketplaceApiUrl(accountId, path), {
    method: 'POST',
    headers: authHeaders(),
  });
  if (!response.ok) throw new Error(`${path} -> HTTP ${response.status}`);
  return response.json();
};

// JSON gövdeli POST → JSON yanıt (ör. sesli asistan sorusu).
export const postMarketplaceJsonBody = async (accountId, path, body) => {
  const response = await fetch(marketplaceApiUrl(accountId, path), {
    method: 'POST',
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    // Sunucu anlamlı bir hata gövdesi döndüyse onu göster (kör HTTP kodu yerine)
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || `${path} -> HTTP ${response.status}`);
  }
  return response.json();
};

// JSON gövdeli PATCH → JSON yanıt (ör. ödeme kontrol işareti güncelleme).
export const patchMarketplaceJson = async (accountId, path, body) => {
  const response = await fetch(marketplaceApiUrl(accountId, path), {
    method: 'PATCH',
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!response.ok) throw new Error(`${path} -> HTTP ${response.status}`);
  return response.json();
};

// multipart/form-data POST (ör. dosya yükleme) → JSON yanıt. Content-Type elle
// EKLENMEZ; tarayıcı boundary'yi kendisi koyar.
export const postMarketplaceForm = async (accountId, path, formData) => {
  const response = await fetch(marketplaceApiUrl(accountId, path), {
    method: 'POST',
    headers: authHeaders(),
    body: formData,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok)
    throw new Error(data.error || `${path} -> HTTP ${response.status}`);
  return data;
};

// DELETE isteği (ör. gider silme); yanıt gövdesi beklenmez.
export const deleteMarketplaceJson = async (accountId, path) => {
  const response = await fetch(marketplaceApiUrl(accountId, path), {
    method: 'DELETE',
    headers: { ...authHeaders() },
  });
  if (!response.ok) throw new Error(`${path} -> HTTP ${response.status}`);
  return true;
};

// GET → ikili (binary) yanıt (ör. Excel/.xls dışa aktarma) blob olarak döner.
export const fetchMarketplaceBlob = async (accountId, path) => {
  const response = await fetch(marketplaceApiUrl(accountId, path), {
    headers: authHeaders(),
  });
  if (!response.ok) throw new Error(`${path} -> HTTP ${response.status}`);
  return response.blob();
};

// JSON gövdeli POST → ikili (binary) yanıt (ör. OpenAI TTS mp3) blob olarak döner.
export const postMarketplaceBlob = async (accountId, path, body) => {
  const response = await fetch(marketplaceApiUrl(accountId, path), {
    method: 'POST',
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!response.ok) throw new Error(`${path} -> HTTP ${response.status}`);
  return response.blob();
};
